export default "__VITE_ASSET__CCtkM$h$__"